import React from "react";
import { BaseIconProps } from "../../types/styles";

const FlagIcon = ({
    id,
    className,
    size = 20,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--error-500)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-flag"}
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4 22V15"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default FlagIcon;
